module.exports = __webpack_public_path__ + "static/media/Бартенев Д.Д..e8fc01fe.pdf";